import { useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";

import { DefeitoMetragemRevisado } from "../components/Tabelas/DefeitoMetragemRevisado";

import Menu from "../components/Menu";

import api from "../services/api";

export default function RelatorioDefeitosMetragem() {
    const [data, setData] = useState(null);
    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());

    const toast = useRef(null);

    const handleSearch = () => {
        let formated1 = initialDate.getFullYear() + '-' + (initialDate.getMonth() + 1) + '-' + initialDate.getDate();
        let formated2 = finalDate.getFullYear() + '-' + (finalDate.getMonth() + 1) + '-' + finalDate.getDate();
        
        api.get(`defeitos/relatorio-metragem/${formated1}/${formated2}`).then((response) => {
            setData(response.data);
            toast.current.show({ summary: 'Concluído', severity: 'success', detail: 'Relatório gerado com sucesso.' });
        }).catch((error) => {
            toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
        });
    }

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card className="p-m-3" title="Relatório Acumulado de Defeitos por Setor">
                <div className="p-fluid p-grid">
                    <div className="p-field p-col-12 p-md-2">
                        <Calendar
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            onChange={e => setInitialDate(e.value)}
                            placeholder="Data Inicial: "
                            value={initialDate}
                        />
                    </div>
                    <div className="p-field p-col-12 p-md-2">
                        <Calendar
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            onChange={e => setFinalDate(e.value)}
                            placeholder="Data Final: "
                            value={finalDate}
                        />
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <Button className="p-button-primary" icon="pi pi-search" onClick={handleSearch} />
                    </div>
                </div>

                <DefeitoMetragemRevisado 
                    data={data ? data.dados : null}
                    totalRevisado={data ? data.total_revisado : null}
                    totalGeral={data ? data.total_geral : null}
                    periodo={data ? data.periodo : null}
                />
                
            </Card>
        </div>
    )
}